query multiviewSearch(
  $orderBy: [EventsOrderBy!] = [STARTS_AT_ASC]
  $condition: EventCondition
  $filter: EventFilter
) {
  events: allEvents(
    orderBy: $orderBy
    condition: $condition
    filter: $filter
    first: 10
  ) {
    nodes {
      eventId
      eventName
      startsAt
      isUsaView
      competition {
        competitionId
        competitionName
      }
    }
  }
}
